import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import FieldErrors from './FieldErrors';
import { ErrorShape, SelectOptionsShape } from '../../utils/shapes';

const Select = ({ id, name, label, touched, error, className, options, ...props }) => (
    <div className={classNames('form-group', className)}>
        {label ? (
            <label htmlFor={id || name}>
                {label}
                {props.required ? <span className="asteriskField">*</span> : null}
            </label>
        ) : null}
        <select
            className={classNames('form-control', { 'is-invalid': error && touched })}
            id={id}
            name={name}
            {...props}
        >
            {options.map((option) => (
                <option value={option.value} key={option.value}>
                    {option.label}
                </option>
            ))}
        </select>
        {error && touched ? <FieldErrors error={error} /> : null}
    </div>
);

Select.propTypes = {
    id: PropTypes.string,
    name: PropTypes.string.isRequired,
    label: PropTypes.node,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),
    placeholder: PropTypes.string,
    touched: PropTypes.bool,
    readOnly: PropTypes.bool,
    disabled: PropTypes.bool,
    multiple: PropTypes.bool,
    error: ErrorShape,
    className: PropTypes.string,
    options: SelectOptionsShape,
    required: PropTypes.bool,
    onChange: PropTypes.func,
    onBlur: PropTypes.func,
};

Select.defaultProps = {
    id: null,
    label: null,
    value: null,
    placeholder: null,
    touched: true,
    readOnly: false,
    disabled: false,
    multiple: false,
    error: null,
    className: null,
    options: [],
    required: false,
    onChange: null,
    onBlur: null,
};

export default Select;



// WEBPACK FOOTER //
// ./src/components/inputs/Select.js